export default function FadeSlide(props) {

  let styles = {
    position: "absolute",
    left: `${props.left}px`,
    top: "0px",
    width: `${props.width}px`,
    height: `${props.height}px`,
    opacity: props.active ? 1 : 0,
    pointerEvents: props.active ? "all" : "none",
    transition: props.transition
  }

  return (
    <div className="slide" style={styles}>
      {props.children}
    </div>
  )
}